import { render } from "./JrFooter.vue?vue&type=template&id=3b1ccafe&scoped=true"
import script from "./JrFooter.vue?vue&type=script&lang=js"
export * from "./JrFooter.vue?vue&type=script&lang=js"

import "./JrFooter.vue?vue&type=style&index=0&id=3b1ccafe&lang=scss&scoped=true"

import exportComponent from "/builds/_flowern/janroedger/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@3.9.7__webpack@4.44.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1ccafe"]])

export default __exports__